import { makeStyles } from '@/styles/theme/tss-react';

const useStyles = makeStyles({
  name: 'BlogCuratedArticleSquareCard',
})(({ brandColors, spacing, breakpoints, typography, aspectRatio }) => ({
  wrapper: {
    width: '100%',
    backgroundColor: brandColors.primaryMain,
    borderRadius: typography.pxToRem(16),
    overflow: 'hidden',
    color: 'white',
    height: 'fit-content',
  },

  imageWrapper: {
    display: 'block',
    aspectRatio: aspectRatio['16/9'],
    alignSelf: 'flex-start',
    width: '100%',
    overflow: 'hidden',
  },

  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    transition: 'transform 0.3s ease-in-out',

    '&:hover': {
      transform: 'scale(1.1)',
    },
  },

  detailsWrapper: {
    padding: spacing(1),

    [breakpoints.up('md')]: {
      padding: spacing(2),
    },
  },

  headingAndDateWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(-1),
  },

  heading: {
    color: brandColors.heroYellow,
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 3,
    textOverflow: 'ellipsis',
    whiteSpace: 'normal',

    '& > a': {
      textDecoration: 'inherit',
    },

    '&:hover': {
      textDecoration: 'underline',
    },
  },

  dateAndCategoryWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(1),
  },
}));

export default useStyles;
